// import { Component, Input } from '@angular/core';

// @Component({
//   selector: 'app-gridBotForm',
//   templateUrl: './gridBotForm.component.html',
//   styleUrls: ['./gridBotForm.component.css']
// })
// export class GridBotForm {
//   @Input() orderStep: any
//   @Input() botDetails: any
//   @Input() orderPlaceDet: any
//   @Input() posDetails: any
//   @Input() closeType: any
// }



import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
@Component({
  selector: 'app-gridBotForm',
  templateUrl: './gridBotForm.component.html',
  styleUrls: ['./gridBotForm.component.css']
})
export class GridBotForm implements OnChanges {
  @Input() botDetails: any;
  @Input() orderStep: string="";
  @Input() orderPlaceDet: any
  @Input() posDetails: any
  @Input() closeType: any

  ngOnChanges(changes: SimpleChanges) {
    console.log(changes, "ngOnChangesngOnChanges")

    if (changes['botDetails'] && this.botDetails) {
      this.botDetails = changes['botDetails'].currentValue
    }
  }
  goToStep(step: string) {
    this.orderStep = step;
  }
}
